import React from 'react';
import {render} from 'react-dom';
import {Provider} from 'react-redux';
import createLogger from 'redux-logger';
import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import qs from 'query-string';
import api from './middleware/api';
import {AppContainer} from 'react-hot-loader';
import Root from './container/Root';

const logger = createLogger()

export default (reducer, config = {}) => {

	const enhancers = [];

	if (process.env.NODE_ENV === 'production') {
		enhancers.push(applyMiddleware(thunk, api))
	} else {
		enhancers.push(applyMiddleware(thunk, api, logger))
	}

	const store = createStore(reducer, {
		query: qs.parse(location.search) || {}
	}, compose(...enhancers));

	return (Page) => {
		render(
				<AppContainer>
					<Provider store={store}>
						<Root config={config} >
							<Page/>
						</Root>
					</Provider>
				</AppContainer>,
				document.querySelector('#app')
		);
	};
};




// WEBPACK FOOTER //
// ./src/renderToApp.js